import { render } from "./TanaoroshiPage.vue?vue&type=template&id=24b53979&scoped=true"
import script from "./TanaoroshiPage.vue?vue&type=script&lang=js"
export * from "./TanaoroshiPage.vue?vue&type=script&lang=js"

import "./TanaoroshiPage.vue?vue&type=style&index=0&id=24b53979&lang=scss&scoped=true"

import exportComponent from "/w/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24b53979"]])

export default __exports__